export class AddWaterResponse {
  constructor(public success: boolean, public waterlog: Waterlog) {}
}

export class UpdateWaterResponse {
  constructor(public success: boolean) {}
}

export class GetWaterResponse {
  constructor(public success: boolean, public waterlogs: Waterlog[]) {}
}

export class Waterlog {
  constructor(public amount: number, public date: number, public _id: string) {}
}

export class Waterlogs {
  constructor(public waterlogs: Waterlog[], public updatedAt: string) {}
}
